var modiferKeyMap = {
    control: 'ctrlKey',
    shift: 'shiftKey',
    alt: 'altKey',
    meta: 'metaKey'
};
export default (function (keys) { return keys.map(function (k) { return modiferKeyMap[k]; }); });
